/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  GetApiReportActivitiesQueryResponse,
  GetApiReportActivitiesQueryParams,
} from '../models/GetApiReportActivities.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { getApiReportActivitiesQueryResponseSchema } from '../zod/getApiReportActivitiesSchema.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getApiReportActivitiesQueryKey = (
  params: GetApiReportActivitiesQueryParams,
) => [{ url: '/api/report/activities' }, ...(params ? [params] : [])] as const;

export type GetApiReportActivitiesQueryKey = ReturnType<
  typeof getApiReportActivitiesQueryKey
>;

/**
 * {@link /api/report/activities}
 */
export async function getApiReportActivities(
  params: GetApiReportActivitiesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiReportActivitiesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: `/api/report/activities`,
    params,
    ...requestConfig,
  });
  return getApiReportActivitiesQueryResponseSchema.parse(res.data);
}

export function getApiReportActivitiesQueryOptions(
  params: GetApiReportActivitiesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiReportActivitiesQueryKey(params);
  return queryOptions<
    GetApiReportActivitiesQueryResponse,
    ResponseErrorConfig<Error>,
    GetApiReportActivitiesQueryResponse,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiReportActivities(params, config);
    },
  });
}

/**
 * {@link /api/report/activities}
 */
export function useGetApiReportActivities<
  TData = GetApiReportActivitiesQueryResponse,
  TQueryData = GetApiReportActivitiesQueryResponse,
  TQueryKey extends QueryKey = GetApiReportActivitiesQueryKey,
>(
  params: GetApiReportActivitiesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiReportActivitiesQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & {
      client?: QueryClient;
    };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ?? getApiReportActivitiesQueryKey(params);

  const query = useQuery(
    {
      ...getApiReportActivitiesQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
